'use strict';

const baseBoutique = require('richemont/product/boutiques');

baseBoutique.brandEvents = function () {
    const $document = $(document);
    $document.on('click', '.boutique-swatch-button', function (e) {
        e.preventDefault();
        const $this = $(this);
        const $productCard = $('.boutique-slider-body');
        const thisValue = $this.attr('data-url');
        if ($this.find('.selected').length || $this.attr('disabled') || !thisValue) {
            return;
        }
        $document.trigger('customVariationUpdate', {
            url: thisValue,
            wrapperEle: $productCard,
        });
    });
    $document.on('click', '.boutique-locate-me', function () {
        const $boutiqueBody = $('.boutique-slider-body');
        let validProduct = true;
        const $attrEle = $('.custom-nonswatch-wrapper');
        if ($attrEle.length) {
            $attrEle.each(function () {
                const $this = $(this);
                const selectEleVal = $this.find('select').val();
                if (!selectEleVal) {
                    $this.find('invalid-feedback').addClass('d-block');
                    validProduct = false;
                    return false;
                }
                return true;
            });
        }
        if (validProduct) {
            $boutiqueBody.spinner().start();
            navigator.geolocation.getCurrentPosition(function (position) {
                const lat = position.coords.latitude;
                const lng = position.coords.longitude;
                const geocoder = new window.google.maps.Geocoder();
                const latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };
                geocoder.geocode({ location: latlng }, function (results, status) {
                    if (status === 'OK') {
                        if (results[0]) {
                            let countryCode = null;
                            results[0].address_components.forEach((component) => {
                                if (component.types.includes('country')) {
                                    countryCode = component.short_name;
                                }
                            });
                            const $countryOption = $('.boutique-country select option[value="' + countryCode + '"]');
                            if ($countryOption.length) {
                                $('.boutique-country select').val(countryCode).change();
                            }
                            $boutiqueBody.spinner().stop();
                        } else {
                            $boutiqueBody.spinner().stop();
                        }
                    } else {
                        $boutiqueBody.spinner().stop();
                    }
                });
            });
        }
    });
    $document.on('input', '.boutique-reserve-comment', function () {
        const $this = $(this);
        const maxLength = parseInt($this.attr('maxlength'), 10);
        const remaining = maxLength - $this.val().length;
        $this.parent().find('.remaining-char').text(remaining);
    });
};

module.exports = baseBoutique;
